<template>
    <div class="carBox" @mouseup="handleMouseUp">
        <el-card ref="left_tree" class="box-card treeBox" style="height: calc(100vh - 152px);width: 300px;overflow-y: auto">
            <el-tree :data="projectDivisionData" node-key="value" :current-node-key="pid" :highlight-current="true" ref="my-tree" @node-click="clickPrjectDivision" :default-expand-all="true" :expand-on-click-node="false"></el-tree>
        </el-card>
        <div ref="resizeHandle" class="handle-resize" />
        <div ref="moveDiv" class="handle-resize-h" />
        <div class="newBox" style="width: calc(100% - 290px)">
        <div class="searchBox">

            <div class="searchGroup">
                <label>单元编号：</label>
                <el-input v-model="search_Obj.f_unit_code" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>排号：</label>
                <el-input v-model="search_Obj.f_base_name" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <el-button type="primary" size="medium" icon="el-icon-search" @click.native="doSearch">搜索</el-button>
        </div>
    <el-card ref="right_content" class="box-card">
        <div class="mainBody">
        <div class="btnBox">
            <Btns :menu_id="menu_id" :menus="main_btns" :ignore_ids="',3251,'" v-if="grade!=3" @on_btnclk="btnClick"></Btns>
                                <Btns :menu_id="menu_id" :menus="main_btns" v-else @on_btnclk="btnClick"></Btns>
        </div>
            <div class="dataBox">
                                <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                                    <el-table-column type="selection" align="center" width="50"></el-table-column>
                                    <el-table-column prop="branch_code" label="分部编号" sortable="custom"></el-table-column>
                                    <el-table-column prop="unit_code" label="单元编号" sortable="custom"></el-table-column>
                                    <el-table-column prop="base_name" label="排号" sortable="custom"></el-table-column>
                                    <el-table-column prop="base_index" label="基础编号" sortable="custom"></el-table-column>
                                    <el-table-column prop="grout_type" label="灌浆类型" sortable="custom" width="120">
                                        <template slot-scope="scope">
                                            <span>{{ transEnu(scope.row.grout_type, "grout_type") }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" width="240" align="center">
                                        <template slot-scope="scope">
                                            <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
            <div class="pageBox">
                                <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                            </div>
        </div>
    </el-card>
</div>
<Edit
                    width="800px"
                    :id="model_id"
                    :title="edit_title"
                    :isshow="editshow"
                    :branch_code="branch_code"
                    @on-close="closeEditDialog"
                    @on-save-ok="saveOk">
                </Edit>
                <Info
                    width="600px"
                    :id="model_id"
                    title="查看排"
                    :isshow="infoshow"
                    @on-close="closeInfoDialog">
                </Info>
                <Import
                    width="600px"
                    title="导入排数据"
                    :isshow="importshow"
                    @on-close="closeImportDialog"
                    @on-imp-ok="impOk">
                </Import>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import Import from "./import"
import listutil from "@/libs/listutil"
import { getProjectDivisionTreeData } from '@/api/org'
import { getListData } from '@/api/common'

export default {
    name: 'arrangeList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns, Import},
    data() {
        return {
            m_name: '排',
            menu_id: 3250,
            list_url: "/api/admin/arrange/list",
            search_Obj: {
                pid: '',
                f_unit_code: '',
                f_base_name: '',
            },
            del_Obj:{
                url:'/api/admin/arrange/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['grout_type'],
            sortData: {
                prop: 'unit_code',
                order: 'ascending'
            },
            grade: 1,
            pid: 0,
            branch_code: '',
            projectDivisionData: [],
            importshow: false,
        };
    },
    mounted(){
        this.dragControllerDiv(this.$refs.left_tree.$el, this.$refs.resizeHandle, this.$refs.moveDiv)
    },
    methods: {
        loadOtherData() {
            this.initTree()
        },
        initTree(){
            this.projectDivisionData = []
            getProjectDivisionTreeData(1).then(res=>{
                if(res.code ==1){
                    var treeData = res.data
                    treeData = this.removeEmptyChild(treeData)
                    this.projectDivisionData = treeData
                    //this.initOpenKeys()
                }
            })
        },
        clickPrjectDivision(data){
            this.pid = data.id
            this.search_Obj.pid = data.id
            this.current = 1
            this.getListData()
            this.list_model = 1
        },
        import(){
            this.importshow = true
        },
        impOk(){
            this.importshow = false
            this.getListData()
        },
        closeImportDialog(){
            this.importshow = false
        },
        getListData() {
            this.loading = true;
            this.selectData = [];
            getListData(this.list_url, this.search_Obj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.tableData = res.data.resultList;
                    this.total = res.data.totalRecords;
                    this.grade = res.data.grade
                    this.pid = res.data.pid
                    if(this.grade ==3){
                        this.branch_code = res.data.branch_code
                    }else{
                        this.branch_code = ''
                    }
                    setTimeout(() => {
                        this.$refs["my-tree"].setCurrentKey(this.pid);
                    }, 1000);
                }
            })
        },
    }
};
</script>